var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: {
        download: "",
        href: _vm.file.url,
        "data-test": "tab-files--download"
      },
      on: {
        mouseover: function($event) {
          return _vm.hover(_vm.file)
        },
        mouseout: function($event) {
          return _vm.hover()
        },
        click: function($event) {
          return _vm.select(_vm.file)
        }
      }
    },
    [
      _c("div", { staticClass: "flex h-10" }, [
        _c(
          "span",
          { staticClass: "h-full flex items-center pr-4" },
          [_c("icon", { attrs: { type: _vm.icon, filled: true } })],
          1
        ),
        _c("div", { staticClass: "w-full" }, [
          _c("h3", { style: _vm.font }, [_vm._v(_vm._s(_vm.file.title))]),
          _c("div", { staticClass: "opacity-50 text-sm" }, [
            _c("span", { staticClass: "uppercase", style: _vm.font }, [
              _vm._v(_vm._s(_vm.type))
            ]),
            _c("span", { staticClass: "px-2" }, [_vm._v("-")]),
            _c("span", [_vm._v(_vm._s(_vm.toMegabyte(_vm.file.size)) + " MB")])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }